/* global Swiper */
// FIXME: item_image_carousel.js をitems.jsの前に置かないと、how-to-pixの画像が表示されなくなっている :(
import '../../../javascripts/item_image_carousel';
import '../../../javascripts/items';
import '../../../javascripts/flash_report';
import Rails from 'rails-ujs';

window.addEventListener('load', () => {
  const swiperContainer = Rails.$('.swiper-container');
  if (swiperContainer.length != 0) {
    // eslint-disable-next-line no-unused-vars
    const mySwiper = new Swiper ('.swiper-container', {
      centeredSlides: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      loop: true,
      speed: 1000,
      slidesPerView: 2,
      breakpoints: {
        767: {
          slidesPerView: 1,
          spaceBetween: 0
        },
      }
    });
  }
});
